var $5d376b7fce1a45b2$exports = {};
$5d376b7fce1a45b2$exports = {
  "dateRange": args => `${args.startDate} \u{2013} ${args.endDate}`,
  "dateSelected": args => `${args.date} valittu`,
  "finishRangeSelectionPrompt": `Lopeta p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
  "maximumDate": `Viimeinen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
  "minimumDate": `Ensimm\xe4inen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
  "next": `Seuraava`,
  "previous": `Edellinen`,
  "selectedDateDescription": args => `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
  "selectedRangeDescription": args => `Valittu aikav\xe4li: ${args.dateRange}`,
  "startRangeSelectionPrompt": `Aloita p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
  "todayDate": args => `T\xe4n\xe4\xe4n, ${args.date}`,
  "todayDateSelected": args => `T\xe4n\xe4\xe4n, ${args.date} valittu`
};
export { $5d376b7fce1a45b2$exports as default };